import { render } from "./accounts.vue?vue&type=template&id=0f5bcc93&lang=html"
import script from "./accounts.vue?vue&type=script&lang=js"
export * from "./accounts.vue?vue&type=script&lang=js"

import "./accounts.vue?vue&type=style&index=0&id=0f5bcc93&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__